import React, { InputHTMLAttributes } from 'react'
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string
  type: string
  placeholder?: string
  label?: string
  labelClassName?: string | undefined
}
const definedClassNames =
  'block border-solid border-[1px] w-[400px] h-[41px] border-gray-400 focus:outline-none rounded-[4px]  px-[20px]'

export const FormInput = (props: InputProps) => {
  const { labelClassName, id, className, placeholder, label, name, ...restProps } = props
  return (
    <>
      {label && (
        <label className={labelClassName} htmlFor={id}>
          {label}
        </label>
      )}
      <input
        {...restProps}
        className={`${className ? '' : definedClassNames}`}
        name={name}
        placeholder={placeholder}
      ></input>
    </>
  )
}
